export const TICKETS_SALE_WIZARD_DETAILS = 'TICKETS_SALE_WIZARD_DETAILS';
export const TICKETS_SALE_WIZARD_SURVEY = 'TICKETS_SALE_WIZARD_SURVEY';
export const TICKETS_SALE_WIZARD_PAYMENT = 'TICKETS_SALE_WIZARD_PAYMENT';
export const TICKETS_SALE_WIZARD_CONFIRMATION = 'TICKETS_SALE_WIZARD_CONFIRMATION';
